import { render, staticRenderFns } from "./LoadingAutocomplete.vue?vue&type=template&id=2f1081b8&scoped=true"
import script from "./LoadingAutocomplete.vue?vue&type=script&lang=js"
export * from "./LoadingAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1081b8",
  null
  
)

export default component.exports